/**
 * Générateur — Automatisme : calculer l'étendue d'une série.
 * Attendu ID : 1248 | Niveau : 3ème | Domaine : Statistiques
 * Rubrique : AUTOMATISME (programme 2025, cycle 4 page 17, ligne 1254).
 *
 * Les clés etd_* de gen_1246 (un fichier « stats », trois jeux de clés,
 * modèle 1101/1105). Ici seules les clés etd_* sont servies ; les payloads
 * portent déjà l'attendu 1248.
 */
import { genererParmi, CATEGORIES_ETENDUE } from './gen_1246';

export const CATEGORIES = CATEGORIES_ETENDUE;
const CLES = CATEGORIES_ETENDUE.flatMap((c) => c.formatsList.map(({ key }) => key));
export const generate = (typeExercice) => genererParmi(CLES, typeExercice);
